import { Report, ReportType } from "../../../DataTypes";
import { downloadFile, formatDateInUTC } from "../../../utils";

const getPath =
  (type: ReportType) =>
  (report: Report, company_id?: number): string => {
    switch (type) {
      case ReportType.SWEEP:
        return company_id !== undefined
          ? `report/sweepstakes/${report.id}/optins-download?company_id=${company_id}`
          : `report/sweepstakes/${report.id}/optins-download`;
      case ReportType.CPL:
        return `report/cpls/${report.id}/optins-download`;
      default:
        throw new Error("invalid report type");
    }
  };

const getFileName = (report: Report): string =>
  `${report.name} ${formatDateInUTC(new Date())}.xlsx`;

const handleDownload =
  (type: ReportType) =>
  (report: Report, company_id?: number): void => {
    const path = getPath(type)(report, company_id);
    const filename = getFileName(report);
    downloadFile(path, filename);
  };

export const handleCplReportDownload = handleDownload(ReportType.CPL);
export const handleSweepReportDownload = handleDownload(ReportType.SWEEP);
